<script setup lang="ts">
/**
 * Style 15 Result (3185:16815; mobile 3183:18258) — summary of what was saved.
 * Open Style goes to Style; Rate more outfits continues rating.
 */
import { useI18n } from 'vue-i18n'
import { useFairCompact } from '@/composables/useFairCompact'
import { FairQuizHero, FairQuizSummary, type FairQuizSummaryRow } from '@/ui/patterns/FairQuiz'
import { FairButton } from '@/ui/primitives/FairButton'

export type StyleQuizSummaryRow = FairQuizSummaryRow

defineProps<{
  rows: StyleQuizSummaryRow[]
}>()

const emit = defineEmits<{
  'rate-more': []
  'open-style': []
}>()

const { t } = useI18n()
/** Mobile: Rate more outfits is a flat button under Open Style. */
const compact = useFairCompact()
</script>

<template>
  <div class="style-quiz-result">
    <FairQuizHero size="result" />

    <div class="fair-quiz-welcome__head">
      <h2 class="fair-quiz-welcome__title">
        {{ t('style_quiz.result.title') }}
      </h2>
      <p class="fair-quiz-welcome__subtitle">
        {{ t('style_quiz.result.subtitle') }}
      </p>
    </div>

    <FairQuizSummary
      class="style-quiz-result__summary"
      :rows="rows"
      :empty="t('style_quiz.result.empty')"
    />

    <div class="style-quiz-result__footer">
      <FairButton
        class="style-quiz-result__more"
        :variant="compact ? 'flat' : 'tonal'"
        size="auto"
        :label="t('style_quiz.result.rate_more')"
        @click="emit('rate-more')"
      />
      <FairButton
        class="style-quiz-result__open"
        variant="primary"
        size="auto"
        :label="t('style_quiz.result.open_style')"
        @click="emit('open-style')"
      />
    </div>
  </div>
</template>
